import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import DialogBox from '../Common/Layout/DialogBox';
import CSS from 'csstype';
import { Colors } from '../../utils/theme';
import Recipients from './Recipients';
import ExcludedRecipients from './ExcludedRecipients';
import CancelButton from '../Common/Buttons/CancelButton';

interface IProps {
  onClose: () => void;
}

const tabStyle = {
  tab: {
    fontSize: 14,
    borderBottom: '1px solid ' + Colors.skyBlue
  },
  active_tab: {
    fontSize: 14,
    fontWeight: 'bold'
  }
};

const RecipientsTabs: React.FunctionComponent<IProps> = ({ onClose }: IProps) => {
  const [value, setValue] = useState(0);

  const getTabStyle = (index: number, tabValue: number): CSS.Properties => {
    const result = index === tabValue ? { ...tabStyle.active_tab } : { ...tabStyle.tab };
    return result as CSS.Properties;
  };

  return (
    <DialogBox id="recipients-tabs" hideTitle width={1400} height={840} onClose={onClose}>
      <Box
        sx={{
          height: '790px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        <Box>
          <AppBar
            position="static"
            style={{ backgroundColor: Colors.white, color: Colors.skyBlue, boxShadow: 'none' }}
          >
            <Tabs
              value={value}
              onChange={(_, newValue) => setValue(newValue)}
              variant="fullWidth"
              TabIndicatorProps={{ style: { background: Colors.skyBlue, height: '3px' } }}
            >
              <Tab
                id="recipients-tab"
                data-testid="recipients-tab"
                label={'Recipients'}
                style={getTabStyle(0, value)}
              />
              <Tab
                id="excluded-recipients-tab"
                data-testid="excluded-recipients-tab"
                label={'Excluded Recipients'}
                style={getTabStyle(1, value)}
              />
            </Tabs>
          </AppBar>
          <Box sx={{ maxHeight: '755px', overflow: 'auto' }}>
            {value === 0 && (
              <Box>
                <Recipients />
              </Box>
            )}
            {value === 1 && (
              <Box>
                <ExcludedRecipients />
              </Box>
            )}
          </Box>
        </Box>
        <Box className="centralize">
          <CancelButton id="close-recipients-tabs-button" text="Close" onClick={onClose} />
        </Box>
      </Box>
    </DialogBox>
  );
};

export default RecipientsTabs;
